import { PaymentDetailsView } from "@portal/BaseComponents/Activites/Payment/PaymentDetailsView/PaymentDetailView";
import { PTPDetails } from "@portal/BaseComponents/Activites/PromiseToPay/PTPDetailsView/PTPDetails";
import { CreditDetailsView } from "@portal/BaseComponents/DetailsView/CreditsDetailView/CreditDetailView";
import { InvoiceDetailsView } from "@portal/BaseComponents/DetailsView/InvoiceDetailsView/InvoiceDetailsView";
import { ProfileTab } from "@portal/Components/Portal/PotalTabs/Profile/ProfileTab";
import { AppPageName } from "@portal/lib/router/constants/page-info";
import { CreditNotesPage } from "@portal/pages/CreditNotes/CreditNotesPage";
import { DisputeDetails } from "@portal/pages/DisputeDetails/DisputeDetails";
import { DisputeListPage } from "@portal/pages/DisputesList/DisputeListPage";
import { DocumentListPage } from "@portal/pages/DocumentList/DocumentListPage";
import { InvoiceListPage } from "@portal/pages/InvoiceList/InvoiceListPage";
import { Login } from "@portal/pages/Login/Login";
import { PTPListsPage } from "@portal/pages/PTPList/PTPListsPage";
import { PaymentListPage } from "@portal/pages/PaymentList/PaymentListPage";
import Portal from "@portal/pages/Portal/Portal";

type PageComponents = Readonly<Record<AppPageName[number], JSX.Element>>;
function usePageComponents() {
  const pageComponents: PageComponents = Object.freeze({
    LOGIN: <Login />,
    FORGOT_PASSWORD: <div />,
    PORTAL: <Portal />,
    INVOICES: <InvoiceListPage />,
    PAYMENTS: <PaymentListPage />,
    CREDIT_NOTES: <CreditNotesPage />,
    DISPUTES: <DisputeListPage />,
    PTPs: <PTPListsPage />,
    DOCUMENTS: <DocumentListPage/>,
    PROFILE: <ProfileTab />,
    INVOICE_DETAILS: <InvoiceDetailsView />,
    DISPUTE_DETAILS: <DisputeDetails />,
    PTP_DETAILS: <PTPDetails />,
    CREDIT_DETAILS: <CreditDetailsView />,
    PAYMENT_DETAILS:<PaymentDetailsView/>
  });

  return { pageComponents };
}

export { usePageComponents };
